//@passback_params 公用回传参数，如果请求时传递了该参数，该参数原样返回,和后台约定使用字符串
export function toWebsocketData(cmd,data,passback_params) {
    let _pb = passback_params || ''
    return  {t: cmd, d:data||{},pb:_pb}
}